import { Button } from "@etudescarre/ui";
import { useState } from "react";
import { toaster } from "@/app";
import { apiClient } from "@/lib/api/client";
import { useYardContext } from "@/providers/yard-context";

// Valider la saisie d'un rapport d'examen. Le back-end vérifie la
// complétude (métadonnées, fichier, au moins un avis porteur d'un statut) et
// persiste le statut. Les messages de complétude renvoyés sont affichés tels
// quels (déjà en français).

type ReportValidationProps = {
  reportId: number;
  onValidated?: () => void;
};

export function ReportValidation({
  reportId,
  onValidated,
}: ReportValidationProps) {
  const { yard } = useYardContext();
  const [isValidating, setIsValidating] = useState(false);

  const handleValidate = async () => {
    setIsValidating(true);
    try {
      const { error } = await apiClient.POST(
        "/api/yards/{yardId}/reports/{reportId}/validate",
        {
          params: {
            path: { yardId: String(yard.id), reportId: String(reportId) },
          },
        },
      );

      if (error) {
        toaster.error({
          title: "Erreur",
          description: error.error ?? "Échec de la validation du rapport",
        });
        return;
      }

      toaster.success({
        title: "Succès",
        description: "Rapport validé",
      });
      onValidated?.();
    } catch {
      toaster.error({
        title: "Erreur",
        description: "Une erreur est survenue",
      });
    } finally {
      setIsValidating(false);
    }
  };

  return (
    <div className="flex justify-end pt-2">
      <Button type="button" onClick={handleValidate} disabled={isValidating}>
        {isValidating ? "Validation en cours..." : "Valider le rapport"}
      </Button>
    </div>
  );
}
